import { Textarea } from '../../../components/ui/textarea';
import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';

export const OTRApprovalActionBar = ({ onApprove, onReject, onSendBack, isLoading, error = '' }) => {
  const [remarks, setRemarks] = useState('');

  return (
    <div className="mt-8 p-6 bg-white rounded-2xl border border-[var(--color-border)] shadow-md">
      <h3 className="text-sm font-bold text-foreground mb-4 uppercase tracking-wider">Approver Actions</h3>

      <div className="mb-5">
        <label className="block text-[12px] font-bold text-[var(--color-text-secondary)] mb-1.5 ml-1">
          Remarks <span className="text-[var(--color-error)]">*</span>
          <span className="ml-2 font-normal opacity-70">(required for Send Back / Reject, max 100 characters)</span>
        </label>
        <Textarea
          value={remarks}
          maxLength={100}
          onChange={(e) => setRemarks(e.target.value)}
          placeholder="Enter your remarks here..."
          className="min-h-[100px] rounded-xl border-[var(--color-text-border)] bg-white text-sm resize-none"
        />
      </div>

      {error && (
        <div className="mb-4 p-3 rounded-xl border border-[var(--color-error)]/20 bg-[var(--color-error)]/5 text-sm text-[var(--color-error)]">
          {error}
        </div>
      )}

      <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
        <Button
          variant="outline"
          onClick={() => onSendBack(remarks)}
          disabled={isLoading || !remarks.trim()}
          className="h-11 w-full sm:w-auto px-6 rounded-xl border-[var(--color-text-border)] text-foreground hover:bg-[var(--color-warning)]/10 hover:text-[var(--color-warning-fg)] hover:border-[var(--color-warning)]/30"
        >
          Send Back
        </Button>
        <Button
          variant="outline"
          onClick={() => onReject(remarks)}
          disabled={isLoading || !remarks.trim()}
          className="h-11 w-full sm:w-auto px-6 rounded-xl border-[var(--color-text-border)] text-foreground hover:bg-[var(--color-error)]/10 hover:text-[var(--color-error)] hover:border-[var(--color-error)]/30"
        >
          Reject
        </Button>
        <Button
          onClick={() => onApprove(remarks)}
          disabled={isLoading}
          className="h-11 w-full sm:w-auto px-8 rounded-xl bg-[var(--color-primary)] text-white hover:bg-[var(--color-accent)] shadow-[0_8px_20px_-8px_rgba(30,51,131,0.5)]"
        >
          {isLoading ? 'Processing...' : 'Approve Request'}
        </Button>
      </div>
    </div>
  );
};